import angular from 'angular';
import uiRouter from 'angular-ui-router';
import insuranceComponent from './insurance.component';
import insuranceListComponent from './insurance-list.component';
import insuranceDetailComponent from './insurance-detail.component';
import InsuranceService from './insurance.service';
import insuranceStateListComponent from "./insurance-state-list.component";
import insuranceStateDetailComponent from "./insurance-state-detail.component";
import insuranceCityDetailComponent from "./city/insurance-city-detail.component";

let insuranceModule = angular.module('insurance', [
  uiRouter
])

.service('Insurance', InsuranceService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/insurance');

  $stateProvider
    .state('insurance', {
      component: 'insurance'
    })
    .state('insurance.list', {
      url: '/insurance',
      component: 'insuranceList'
    })
    .state('insurance.create', {
      url: '/insurance/new',
      component: 'insuranceDetail',
      params: {
      	id: ""
      }
    })
    .state('insurance.edit', {
      url: '/insurance/:id/edit',
      component: 'insuranceDetail',
      params: {
        id: ""
      }
    })
    .state('insurance.state', {
      url: '/insurance/states',
      component: 'insuranceStateList'
    })
    .state('insurance.screate', {
      url: '/insurance/states/new',
      component: 'insuranceStateDetail',
      params: {
        id: ""
      }
    })
    .state('insurance.sedit', {
      url: '/insurance/states/:id/edit',
      component: 'insuranceStateDetail',
      params: {
        id: ""
      }
    })
    .state('insurance.ccreate', {
      url: '/insurance/city/:uf/new',
      component: 'insuranceCityDetail',
      params: {
        uf: ""
      }
    })
    .state('insurance.cedit', {
      url: '/insurance/city/:uf/:id/edit',
      component: 'insuranceCityDetail',
      params: {
        uf: "",
        id: ""
      }
    });
})

.component('insurance', insuranceComponent)
.component('insuranceList', insuranceListComponent)
.component('insuranceStateList', insuranceStateListComponent)
.component('insuranceDetail', insuranceDetailComponent)
.component('insuranceStateDetail', insuranceStateDetailComponent)
.component('insuranceCityDetail', insuranceCityDetailComponent)

.name;

export default insuranceModule;



// WEBPACK FOOTER //
// ./client/app/components/insurance/insurance.js